import { render, staticRenderFns } from "./SvgAgenda.vue?vue&type=template&id=1160b838&"
import script from "./SvgAgenda.vue?vue&type=script&lang=js&"
export * from "./SvgAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports